import AppraiserAllocationForm from './AppraiserAllocationForm';

export default AppraiserAllocationForm;
